import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, SECTION_STYLE_FIELDS } from './_fields'

/** Rounded photo tiles linking to the posts; the variant sets the columns. */
export const schema: ComponentSchema = {
  type: 'instagram-feed',
  label: 'Social feed',
  description: 'Photo tiles from your social account, each linking to its post.',
  supportedPages: CONTENT_PAGES,
  variants: [
    { id: 'v1', label: 'Grid, 5 columns' },
    { id: 'v2', label: 'Grid, 6 columns' },
    { id: 'v3', label: 'Grid, 4 columns' },
    { id: 'v4', label: 'Masonry, 4 columns' },
  ],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Playtime with our little customers' },
    { key: 'handle', label: 'Handle', type: 'string', placeholder: '@yourkidsstore' },
    {
      key: 'items',
      label: 'Photos',
      type: 'array',
      itemSchema: [
        { key: 'image', label: 'Photo', type: 'image' },
        { key: 'link', label: 'Post link', type: 'string' },
      ],
    },
    ...SECTION_STYLE_FIELDS,
  ],
}
